<template>
  <div class="myApi">
    <div class="title">申请API</div>
    <p class="page-description">选择需要的图书接口，申请后即可开始调用。</p>
    <div class="box" v-if="list.length > 0">
      <div class="item" v-for="item in list" :key="item.id">
        <img :src="item.imgUrl" alt="" class="item-img" />
        <div class="application-info">
          <div class="item-name item-bottom">{{ item.name }}</div>
          <div class="item-bottom">申请赠送：{{ item.defaultCount }}次</div>
        </div>
        <button
          class="nowApplyBtn"
          :disabled="item.applied || applying"
          :class="{ disableClick: item.applied }"
          @click="applyFree(item)"
        >
          {{ item.applied ? '已申请' : '立即申请' }}
        </button>
      </div>
    </div>
    <div v-else class="noData">
      <img :src="emptyUrl" alt="" class="url" />
      <span class="content">暂无数据</span>
    </div>
  </div>
</template>

<script>
import { applyApiList, applyInterface } from '@/api/common'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      list: [],
      applying: false
    }
  },
  computed: {
    ...mapState(['emptyUrl'])
  },
  methods: {
    async applyFree (item) {
      if (item.applied || this.applying) return
      this.applying = true
      try {
        const result = await applyInterface(item.id)
        // 响应式状态同步按钮文案，避免重复申请。
        this.$set(item, 'applied', true)
        this.$toast.success({ message: result.data, duration: 1500 })
      } finally {
        this.applying = false
      }
    }
  },
  async created () {
    const result = await applyApiList()
    this.list = result.data
  }
}
</script>

<style lang="less" scoped>
.myApi {
  width: 100%;
  padding: 30px 40px;
  .title {
    color: #333;
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 22px;
  }
  .noData {
    display: flex;
    // 修改主轴方向；row（默认值，水平方向）column：垂直方向
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .url {
      width: 500px;
      height: 300px;
    }
    .content {
      color: #cacdd1;
    }
  }
  .box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      display: flex;
      align-items: center;
      width: 49%;
      border: 1px solid #eee;
      margin-bottom: 30px;
      padding: 20px;
      .nowApplyBtn {
        padding: 3px 8px;
        margin-left: 0;
        background-color: #00bdff;
        font-size: 16px;
        color: #fff;
        border-radius: 6px;
        cursor: pointer;
        border: none;
      }
      .disableClick {
        background: #a7aaa5;
      }
      .item-name {
        font-size: 18px;
      }
      .item-bottom {
        margin-bottom: 5px;
      }
      .item-img {
        width: 50px;
        height: 50px;
        margin-right: 40px;
      }
    }
  }
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .myApi {
    padding: 15px 12px;

    .title {
      font-size: 20px;
      margin-bottom: 15px;
    }

    .noData {
      .url {
        width: 200px;
        height: 120px;
      }
      .content {
        font-size: 14px;
      }
    }

    .box {
      .item {
        width: 100%;
        margin-bottom: 15px;
        padding: 12px;
        flex-wrap: wrap;

        .item-img {
          width: 40px;
          height: 40px;
          margin-right: 15px;
        }

        .item-name {
          font-size: 15px;
        }

        .item-bottom {
          font-size: 12px;
          margin-bottom: 3px;
        }

        .nowApplyBtn {
          margin-left: 0;
          margin-top: 10px;
          width: 100%;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
